import { render, staticRenderFns } from "./ActivityLog.vue?vue&type=template&id=5a6580a4&scoped=true"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"
import style0 from "./ActivityLog.vue?vue&type=style&index=0&id=5a6580a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6580a4",
  null
  
)

export default component.exports